import { useMemo, useRef } from 'react';

function injectZendeskScript(): void {
  const key = '36992a6c-1f30-43f4-b3f3-7b11c6293b28';
  const el = document.createElement('script');
  el.id = 'ze-snippet';
  el.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;
  document.head.appendChild(el);
}

export interface ZendeskHook {
  initialize(token: string): void;
}

export function useZendesk(): ZendeskHook {
  const initializedRef = useRef(false);
  return useMemo(() => ({
    initialize(token: string) {
      if (!initializedRef.current && token) {
        window.zESettings = {
          webWidget: {
            authenticate: {
              jwtFn(callback) {
                callback(token);
              },
            },
          },
        };
        injectZendeskScript();
        initializedRef.current = true;
      }
    },
  }), []);
}
